import React, {cloneElement, Fragment, useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {selectOrganizationTemplates, uploadRefundToExcelAsync} from "../../../../store/reducers/excel/excelReducer";
import {Translate} from "../../../../lang/lang";
import {selectLang} from "../../../../store/reducers/main/main";
import {TYPE_REFUND} from "../../../../enum/excel/ExcelTemplateTypes";
import {downloadFile} from "../../../../helpers/excel-uploader";
import {Button, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import IconCloudDownload from "../../../../assets/icon/IconCloudDownload";

const UploadRefundToExcel = ({id, number, children, ...props}) => {

    const [refundTypeTemplates, setRefundTypeTemplates] = useState([]);
    const organizationTemplates = useSelector(selectOrganizationTemplates);
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_REFUND) || [];
        setRefundTypeTemplates(templates);
    }, [organizationTemplates])

    const uploadRefund = (uri) => {
        setLoading(true);
        uploadRefundToExcelAsync({uri: uri, id: id})
            .then(({content, contentType}) => {
                downloadFile({
                    content: content,
                    contentType: contentType,
                    fileName: t(lang, "warehouse.item.download_excel.refund_name", {number: number}),
                });
            })
            .catch((error) => console.log("error", error))
            .finally(() => setLoading(false))
    }

    return (
        <Fragment>
            {refundTypeTemplates.length > 1
                ?
                <Dropdown {...props}>
                    <Dropdown.Toggle bsPrefix="toggle" variant="phoenix-secondary" className="btn-white-davr d-flex gap-2 align-items-center" size="sm" disabled={loading}>
                        {!!children
                            ?
                            <div>
                                {!!loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                                {!loading && cloneElement(children, {...children.props})}
                            </div>
                            :
                            <div>
                                {loading
                                    ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                                    : <IconCloudDownload />
                                }
                                <span className="d-none d-sm-inline-block">
                                    {t(lang, 'warehouse.operation.item.common.download_excel')}
                                </span>
                            </div>
                        }
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='py-2'>
                        {refundTypeTemplates.map((template, index) => (
                            <Dropdown.Item key={index} onClick={() => uploadRefund(template.uri)}>
                                {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                :
                <Fragment>
                    {!!children
                        ?
                        <Button className={'btn-white-davr d-flex align-items-center gap-2'} variant="phoenix-secondary" size="sm" disabled={loading} {...props} onClick={() => {
                            const [defaultTemplate] = refundTypeTemplates;
                            uploadRefund(defaultTemplate.uri);
                        }}>
                            {cloneElement(children, {...children.props})}
                        </Button>
                        :
                        <Button {...props} className={'btn-white-davr d-flex align-items-center gap-2'} variant="phoenix-secondary" size="sm" disabled={loading} onClick={() => {
                            const [defaultTemplate] = refundTypeTemplates;
                            uploadRefund(defaultTemplate.uri);
                        }}>
                            {loading
                                ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                                : <IconCloudDownload />
                            }

                            <span className="d-none d-sm-inline-block">{t(lang, 'warehouse.operation.item.common.download_excel')}</span>
                        </Button>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default UploadRefundToExcel;
